import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';

const VoiceAgentDataContext = createContext();

// Dummy data for different user roles
const adminVoiceAgentData = {
  totalAgents: 15,
  activeAgents: 12,
  totalCalls: 2500,
  averageCallDuration: '4.5m',
  satisfactionRate: '94%',
  agents: [
    {
      id: 1,
      name: 'Customer Service Bot',
      type: 'Customer Service',
      status: 'active',
      calls: 850,
      satisfaction: '96%',
      lastActive: '2024-03-21T10:30:00',
      apiKey: 'va_sk_...',
      usage: {
        total: 50000,
        used: 25000,
        remaining: 25000
      }
    },
    {
      id: 2,
      name: 'Sales Assistant',
      type: 'Sales',
      status: 'active',
      calls: 650,
      satisfaction: '92%',
      lastActive: '2024-03-21T09:15:00',
      apiKey: 'va_sk_...',
      usage: {
        total: 50000,
        used: 30000,
        remaining: 20000
      }
    }
  ],
  statistics: {
    callsByDay: [
      { day: 'Mon', count: 180 },
      { day: 'Tue', count: 195 },
      { day: 'Wed', count: 210 },
      { day: 'Thu', count: 190 },
      { day: 'Fri', count: 220 },
      { day: 'Sat', count: 160 },
      { day: 'Sun', count: 145 }
    ],
    agentTypes: [
      { type: 'Customer Service', count: 6 },
      { type: 'Sales', count: 5 },
      { type: 'Technical Support', count: 4 }
    ]
  }
};

const userVoiceAgentData = {
  totalAgents: 2,
  activeAgents: 1,
  totalCalls: 150,
  averageCallDuration: '3.2m',
  satisfactionRate: '91%',
  agents: [
    {
      id: 1,
      name: 'My Support Bot',
      type: 'Customer Service',
      status: 'active',
      calls: 120,
      satisfaction: '93%',
      lastActive: '2024-03-21T10:30:00',
      apiKey: 'va_sk_...',
      usage: {
        total: 10000,
        used: 5000,
        remaining: 5000
      }
    }
  ],
  statistics: {
    callsByDay: [
      { day: 'Mon', count: 20 },
      { day: 'Tue', count: 25 },
      { day: 'Wed', count: 30 },
      { day: 'Thu', count: 25 },
      { day: 'Fri', count: 35 },
      { day: 'Sat', count: 10 },
      { day: 'Sun', count: 5 }
    ],
    agentTypes: [
      { type: 'Customer Service', count: 1 },
      { type: 'Sales', count: 1 }
    ]
  }
};

export const VoiceAgentDataProvider = ({ children }) => {
  const { currentUser, isAdmin } = useAuth();

  // Get data based on user role
  const getVoiceAgentData = () => {
    if (isAdmin()) {
      return adminVoiceAgentData;
    }
    return userVoiceAgentData;
  };

  const value = {
    voiceAgentData: getVoiceAgentData(),
    isAdmin: isAdmin()
  };

  return (
    <VoiceAgentDataContext.Provider value={value}>
      {children}
    </VoiceAgentDataContext.Provider>
  );
};

export const useVoiceAgentData = () => {
  const context = useContext(VoiceAgentDataContext);
  if (!context) {
    throw new Error('useVoiceAgentData must be used within a VoiceAgentDataProvider');
  }
  return context;
};

export default VoiceAgentDataContext; 